import { authClient, API } from "../index";

// Respuestas de las mesas de una sesión (con mesa populada)
export const getContributionsBySession = sessionId => {
	return authClient().get(`${API}/contribution/session/${sessionId}`);
};

// Corregir una respuesta de mesa: { text }
export const updateContribution = (id, body) => {
	return authClient().put(`${API}/contribution/${id}`, body);
};

// Eliminar respuesta de mesa
export const deleteContribution = id => {
	return authClient().delete(`${API}/contribution/${id}`);
};
